// Modul zur Erfassung von Kosten mit Pauschale
"use strict";

import module from "./module.js";

export default module;
